import { render, staticRenderFns } from "./Blackfriday.vue?vue&type=template&id=161af808&"
import script from "./Blackfriday.vue?vue&type=script&lang=js&"
export * from "./Blackfriday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports